import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight, Clock, Tag } from "lucide-react";
import { blogPosts as mockBlogList, galleryImages } from "../data/mock";
import { useBlogPosts } from "../hooks/useContent";
import PageHero from "../components/PageHero";

export default function BlogPage() {
  const { data: blogPosts } = useBlogPosts();
  return (
    <div>
      <Helmet>
        <title>Blog Funerar – Ghiduri & Informații Utile | Casa Funerară Sfântul Andrei</title>
        <meta name="description" content="Articole utile despre servicii funerare, ajutor de înmormântare, tradiții ortodoxe și legislație funerară în România. Ghiduri practice de la Casa Funerară Sfântul Andrei Constanța." />
        <link rel="canonical" href="https://funeraresfantulandrei.ro/blog" />
        <meta property="og:title" content="Blog Funerar – Ghiduri & Informații Utile | Casa Funerară Sfântul Andrei" />
        <meta property="og:url" content="https://funeraresfantulandrei.ro/blog" />
      </Helmet>
      <PageHero
        image={galleryImages.sfAndreiIcoana}
        title="Blog & Resurse Utile"
        subtitle="Ghiduri practice, informații despre legislație și tradiții funerare, pentru a vă ajuta în momentele dificile."
        breadcrumbs={[
          { label: "Acasă", to: "/" },
          { label: "Blog" },
        ]}
      />

      <section className="section-spacing bg-white">
        <div className="max-w-[1140px] mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 stagger-children">
            {(Array.isArray(blogPosts) ? blogPosts : []).map((post, i) => {
              const hasContent = !!post.content;
              const Wrapper = hasContent ? Link : "div";
              const wrapperProps = hasContent ? { to: `/blog/${post.slug}`, className: "blog-card group no-underline block" } : { className: "blog-card group" };

              return (
                <Wrapper key={i} {...wrapperProps}>
                  {post.image && (
                    <div className="img-hover-zoom aspect-[16/9]">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  )}
                  <div className="p-8">
                    <div className="flex items-center gap-4 mb-5">
                      <span className="flex items-center gap-1.5 text-xs" style={{ color: "#999" }}>
                        <Tag className="w-3 h-3" />
                        {post.category}
                      </span>
                      <span className="flex items-center gap-1.5 text-xs" style={{ color: "#999" }}>
                        <Clock className="w-3 h-3" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2
                      className="text-xl font-semibold mb-4 group-hover:opacity-70 transition-opacity"
                      style={{ fontFamily: "'Playfair Display', serif", color: "#0f0f0f" }}
                    >
                      {post.title}
                    </h2>
                    <p className="text-sm leading-relaxed mb-6" style={{ color: "#999" }}>
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs" style={{ color: "#ccc" }}>{post.date}</span>
                      {hasContent && (
                        <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ color: "var(--gold)" }}>
                          Citește
                          <ArrowRight className="w-3 h-3" />
                        </span>
                      )}
                      {!hasContent && (
                        <span className="text-[10px] font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full" style={{ color: "var(--gold)", backgroundColor: "var(--gold-bg)" }}>
                          În curând
                        </span>
                      )}
                    </div>
                  </div>
                </Wrapper>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
